import React from 'react';
import clsx from 'clsx';

export interface OverlineProps extends React.HTMLAttributes<HTMLSpanElement> {
    tone?: 'accent' | 'muted' | 'onBrand';
}

/** 11px tracked uppercase eyebrow. */
export const Overline: React.FC<OverlineProps> = ({ tone = 'muted', className, children, ...props }) => (
    <span
        className={clsx(
            'block text-overline uppercase',
            tone === 'accent' && 'text-ink-accent',
            tone === 'muted' && 'text-ink-muted',
            tone === 'onBrand' && 'text-accent-300',
            className,
        )}
        {...props}
    >
        {children}
    </span>
);
export default Overline;
